$(function() {
    var $formsContainer = $(".umbraco-forms-form");
    var $fieldsThatNeedLabel = $formsContainer.find("input, select");
    var $checkboxLists = $formsContainer.find(".checkboxlist");
    var $radioLists = $formsContainer.find(".radiobuttonlist");

    //Set aria-label on input fields if they don't have one - This is to optimize Umbraco Forms accessibility
    $fieldsThatNeedLabel.each(function() {
        var $self = $(this);

        if (!$self.attr("aria-label")) {
            var $parentLabel = $self.parent().prev();

            if ($parentLabel.is("label")) {
                $self.attr("aria-label", $.trim($parentLabel.text()));
            } else {
                $self.attr("aria-label", " ");
            }
        }
    });

    //Add group and label to check box lists
    $checkboxLists.each(function() {
        var $parentContainer = $(this);

        if (!$parentContainer.attr("role")) {
            $parentContainer.attr("role", "group").attr("aria-label", "Check box list");
        }
    });

    //Add group and label to radiobutton lists
    $radioLists.each(function () {
        var $parentContainer = $(this);

        if (!$parentContainer.attr("role")) {
            $parentContainer.attr("role", "radiogroup").attr("aria-label", "Radio button list");
        }
    });
});